import { render, staticRenderFns } from "./MangheHomeColor.vue?vue&type=template&id=089128c4&"
import script from "./MangheHomeColor.vue?vue&type=script&lang=js&"
export * from "./MangheHomeColor.vue?vue&type=script&lang=js&"
import style0 from "./MangheHomeColor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports